import * as atgApi from "../../services/atg";
import { Logger } from "@lululemon/ecom-pdp/src/utils/logger";

export const FILTER_LOCAL_STORE_LOCATIONS = "FILTER_LOCAL_STORE_LOCATIONS";
export const SET_ALL_STORE_LOCATIONS = "SET_ALL_STORE_LOCATIONS";
export const ALL_STORE_LOCATIONS_ERROR = "ALL_STORE_LOCATIONS_ERROR";
export const SET_LOCAL_STORES_WITH_INVENTORY_DATA =
  "SET_LOCAL_STORES_WITH_INVENTORY_DATA";
import { getFormattedRawStores, formatStores } from "../../services/stores/";
import fetchStores from "../../graphql/fetchStores";

export function setAllStoreLocations(json) {
  return {
    type: SET_ALL_STORE_LOCATIONS,
    payload: {
      data: json,
      receivedAt: Date.now(),
    },
  };
}

export function storeLocationsError(error) {
  return {
    type: ALL_STORE_LOCATIONS_ERROR,
    payload: {
      error,
    },
  };
}

// @TODO-bopis; remove after BOPIS feature flag is removed
export function fetchAllStoreLocations() {
  return (dispatch) => {
    return fetch(atgApi.getStoresLocationUrl())
      .then((response) => response.json())
      .then((json) => dispatch(setAllStoreLocations(json)))
      .catch((reason) => {
        dispatch(storeLocationsError(reason));
        return Promise.reject(reason);
      });
  };
}

export function fetchAllStoreLocationsBOPIS() {
  return (dispatch) => {
    return fetch(atgApi.getStoresLocationUrl())
      .then((response) => response.json())
      .then((json) => {
        const formattedStores = { stores: getFormattedRawStores(json.stores) };
        dispatch(setAllStoreLocations(formattedStores));
      })
      .catch((reason) => {
        dispatch(storeLocationsError(reason));
        return Promise.reject(reason);
      });
  };
}

// @TODO-bopis; remove after BOPIS feature flag is removed
export function fetchAllStoreLocationsIfNeeded() {
  return (dispatch, getState) => {
    const data = getState().rootReducer.storeLocations.stores;
    // if no data already in store - make a request
    // otherwise, data is already cached in the store
    return !data || !data.length
      ? dispatch(fetchAllStoreLocations())
      : Promise.resolve();
  };
}

export function fetchAllStoreLocationsIfNeededBOPIS() {
  return (dispatch, getState) => {
    const data = getState().rootReducer.storeLocations.stores;
    // if no data already in store - make a request
    // otherwise, data is already cached in the store
    return !data || !data.length
      ? dispatch(fetchAllStoreLocationsBOPIS())
      : Promise.resolve();
  };
}

const fetchStoresEGT = async () => {
  const response = await fetch(atgApi.getStoresLocationUrl());
  const json = await response.json();
  return getFormattedRawStores(json.stores);
};

export const fetchStoreLocatorList = async (graphqlClient) => {
  const stores = await fetchStores(graphqlClient);
  return formatStores(stores);
};

export function fetchStoreLocationsIfNeeded(
  graphqlClient,
  storeLocatorListQueryLDFlag
) {
  return async (dispatch, getState) => {
    const data = getState().rootReducer.storeLocations.stores;
    let stores;
    // if no data already in store - make a request
    // otherwise, data is already cached in the store
    if (!data?.length) {
      try {
        stores = await (storeLocatorListQueryLDFlag
          ? fetchStoreLocatorList(graphqlClient)
          : fetchStoresEGT());
        dispatch(setAllStoreLocations({ stores }));
      } catch (error) {
        dispatch(storeLocationsError(error));
        Logger.error(
          `Error fetching store locations: ${error?.message || error}`,
          {
            isRedirect: false,
            error,
          }
        );
      }
    }
  };
}
